export const UPDATA_RECORD_DATA = 'personMainPage/UPDATA_RECORD_DATA';
const initialState = {
    recordData:{
        isRecord:false,
        propertyRecord:[
        ],
        roleDialog:false,
        propertyId:''
    }
};


const recordDataReducer =  (recordData={}, action)=>{
    switch (action.type) {
        case UPDATA_RECORD_DATA:
            return {
                ...recordData,
                [action.subType]:action.data
            };
        default:
            return recordData
    }
}

export default (state = initialState, action) => {
    return {
        recordData : recordDataReducer(state.recordData, action)
    };
}

export const dispatch_func = {
    updata_recordData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATA_RECORD_DATA,
                data:data,
                subType:type
            });
        }
    },


};


// WEBPACK FOOTER //
// ./src/modules/personPropertyCheck.js